import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { endPoints } from '../../../../config/end-points';
import useHttp from '../../../../hooks/use-http';
import { settingAction } from '../../../../store/setting-store';
import queryString from 'query-string'
import axios from 'axios';
import { cuteToast } from '../../../UI/cute';

const Aweber = () => {

    const [status, setStatus] = useState(false);

    const code = queryString.parse(window.location.search).code;
    
    const is_autoresponder_loaded = useSelector(
        (state) => state.settings.is_autoresponder_loaded
    );
    const autoresponder_keys = useSelector(
        (state) => state.settings.autoresponder
    );

    const dispatch = useDispatch();

    useEffect(() => {
        if (is_autoresponder_loaded) {
        // console.log(autoresponder_keys);

        const aweber = autoresponder_keys.filter(
            ({ meta_key }) => meta_key === "aweber"
        );

        if (aweber.length > 0) {
            // const meta_data = JSON.parse(activeCampaign[0].meta_data);

            setStatus(aweber[0].status === 1 ? true : false);
        }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [is_autoresponder_loaded]);

    useEffect(()=>{
        // console.log(code)
        async function getAccessToken(){
            console.log(code)
            const TOKEN_URL = 'https://auth.aweber.com/oauth2/token';
            const clientId = "Ql38D1tSFIxbXMDrqwvdJxHjotyTmb8p";
            const redirectUri = window.location.origin+window.location.pathname;

            const response = await axios({
                // make a POST request
                method: "post",
                // to the Github authentication API, with the client ID, client secret
                // and request token
                url: `${TOKEN_URL}?grant_type=authorization_code&code=${code}&redirect_uri=${redirectUri}&code_verifier=HLBvz1g_bbLZ31kjvlXJ5Rl0W1GgxU8rjYJdQIIEH_Y&client_id=${clientId}`,
                // Set the content type header, so that we get the response in JSOn
                headers: {
                  accept: "application/x-www-form-urlencoded",
                },
            })

            if(response && response.status === 200){
                sendRequest(
                    {
                      url: endPoints.insertAutoresponderkeys,
                      method: "POST",
                      body: {
                        meta_key: "aweber",
                        meta_data: response.data,
                      },
                    },
                    (response) => {
                      if (response.status === 200) {
                        cuteToast({
                          type: "success",
                          message: response.message,
                          timer: 5000,
                          title: "success",
                        });
        
                        dispatch(
                          settingAction.setAutoresponderStatus({ status: false })
                        );
                      }
                    }
                  );
            }else{
                cuteToast({
                    type: "error",
                    message: "Something Went Wrong!",
                    timer: 5000,
                    title: "Authorization Error",
                });
            }
        }

        if(code && code !== ''){
            getAccessToken();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[code])

    const { sendRequest } = useHttp();

    const handleConnect = () =>{
        
        const OAUTH_URL = 'https://auth.aweber.com/oauth2',
        // TOKEN_URL = 'https://auth.aweber.com/oauth2/token',
        scopes = [
          'account.read',
          'list.read',
          'list.write',
          'subscriber.read',
          'subscriber.write',
          'email.read',
          'email.write',
          'subscriber.read-extended',
          'landing-page.read'
        ];

        const clientId = "Ql38D1tSFIxbXMDrqwvdJxHjotyTmb8p";

        const redirectUri = window.location.origin+window.location.pathname;
        
        const state = Date.now();

        const authUrl = `${OAUTH_URL}/authorize?client_id=${clientId}&response_type=code&code_challenge=-oiamT7-EafhQ27P3V9cGEtu3crg731kec-GWhgrTV8&code_challenge_method=S256&scope=${scopes.join('+')}&state=${state}&redirect_uri=${redirectUri}`;

        window.location.href = authUrl;
    }

    const disconnectResponder = () => {
        sendRequest(
          {
            url: endPoints.disconnectResponder,
            method: "POST",
            body: {
              meta_key: "aweber",
            },
          },
          (response) => {
            dispatch(settingAction.setAutoresponderStatus({ status: false }));
          }
        );
    };

    return (
        <>
            <div className="row mt-3">
                {!status && (
                    <div className='col-sm-12 text-left p-2'>
                        <p className='mb-2'>Click to connect your Aweber account to VidAmaze.</p>
                        <button className='btn w-25 p-2' onClick={handleConnect}>Connect</button>
                    </div>
                )}

                {status && (
                    <div className="form-group">
                        <button className="btn" onClick={disconnectResponder}>
                            Disconnect
                        </button>
                    </div>
                )}
            </div>  
        </>
    )
}

export default Aweber